
import { Injectable, Type } from '@angular/core';
import { Form, UntypedFormGroup } from '@angular/forms';
import { AddItemToEntityFieldListComponent } from '../../configuration/entities-detail/entities-detail-fields/add-item-to-entity-field-list/add-item-to-entity-field-list.component';
import { LoginService } from '../../login/login.service';

@Injectable({
  providedIn: 'root'
})
export class ComponentService {

  private model: any = null;

  constructor(
    private loginService:LoginService
  ) {}
  
  isVisible(component: any, model:any) {
    let visible = true;

    //validar si se cumple las condiciones de visibilidad
    if (component.visible_by == 'user') {
      //si es el usuario responsable
      visible = this.loginService.isUserResponsible(model);
      if (!visible && this.loginService.isUserSubordinate(model)) visible = true;
    }

    //visibilidad personalizada del componente
    if (visible) visible = this.isVisibleCustom(component, model);


    return visible;
  }

  isVisibleCustom(component: any, model: any) {
    let ret = true;
    this.model = model;
    if (component.ngIf != null) {
      let code = component.ngIf;
      ret = eval(code);
    }
    return ret;
  }

  isEditable(component: any, model: any) {
    let editable = true;
    //si hay modelo de datos cargado, revisamos validaciones de datos
    if (model.id > 0) {

      if (component != null && component.entity == "organization" && this.loginService.hasPermission("ORGANIZATIONS_SUPERADMIN")) return true;
      if (component != null && component.entity == "reports" && this.loginService.hasPermission("REPORTS_SUPERADMIN")) return true;
      if (component != null && component.entity == "users" && this.loginService.hasPermission("USERS_SUPERADMIN")) return true;
      if (component != null && component.entity == "zones" && this.loginService.hasPermission("ZONES_SUPERADMIN")) return true;

      //registros enlazados con ERP no dejamos tocar ventas
      if (component != null && component.entity == "transaction" && model.erp_id != null) return false; //transaccion enlazada con erp
      if (component != null && model.transaction != null && component.entity == "transactionLine" && model.transaction.erp_id != null) return false; //linea transaccion enlazada con erp

      if (component != null && component.entity == "transactionLine" && (this.loginService.hasPermission("TRANSACTIONS_SUPERADMIN") || this.loginService.hasPermission("OPORTUNITIES_SUPERADMIN") || this.loginService.hasPermission("SALES_SUPERADMIN"))) return true;

      //TODO: probar si las transacciones customizadas se llaman componen.entity == transactions o el nombre
      if (component != null && component.entity == "transactions" && this.loginService.hasPermission("TRANSACTIONS_SUPERADMIN")) return true;
      if (component != null && component.entity == "oportunity" && this.loginService.hasPermission("OPORTUNITIES_SUPERADMIN")) return true;
      if (component != null && component.entity == "sale" && this.loginService.hasPermission("SALES_SUPERADMIN")) return true
      if (component != null && component.entity == "task" && this.loginService.hasPermission("TASKS_SUPERADMIN")) return true;
      if (component != null && component.entity == "contact" && this.loginService.hasPermission("ORGANIZATIONS_SUPERADMIN")) return true;
      if (component != null && component.entity == "taskHistory" && this.loginService.hasPermission("TASKS_SUPERADMIN")) return true;


      //si eres responsable
      editable = this.loginService.isUserResponsible(model);
      if (!editable && this.loginService.isUserSubordinate(model)) editable = true;
      let field_editable_by = component.editable_by ?? 'all';
      if (field_editable_by == 'user' && !editable) {
        //fin
      } else if (field_editable_by == 'all' && !editable) {
        //validar por zonas, lo ven todos pero no eres reponsable
        //comprobar si es de mi zona y tengo permiso
        if (this.loginService.isUserZone(model) && this.loginService.isUserZoneWritable(component.entity)) editable = true;
      }
    }

    return editable;
  }

  isVisibleField(field:any, model:any) {
    let visible = true;
    //validar si se cumple las condiciones de visibilidad
    if (field.visible_by == 'user') {
      //si es el usuario responsable
      visible = this.loginService.isUserResponsible(model);
      if (!visible && this.loginService.isUserSubordinate(model)) visible = true;
    }
    //visibilidad personalizada del campo
    if (visible) visible = this.isVisibleFieldCustom(field, model);

    return visible;
  }

  isVisibleHeaderFieldCustom(field: any) {
    let ret = true;
    if (field.entityField != null && field.entityField.configuration != null && field.entityField.configuration.ngIf != null) {
      let code = field.entityField.configuration.ngIf;
      ret = eval(code);
    }
    return ret;
  }

  isVisibleFieldCustom(field: any, model: any) {
    let ret = true;
    this.model = model;
    if (field.entityField != null && field.entityField.configuration != null && field.entityField.configuration.ngIf != null) {
      let code = field.entityField.configuration.ngIf;
      try {
        
        ret = eval(code);
        this.loginService.hasFeature(42);

      } catch (e) {
        console.log(e);
        console.error("Error: " + code, field, model);
      }
    }


    return ret;
  }

  isDisabledFieldCustom(field: any, component: any) {
    /*if (field.model_property == "responsible_id") {
      console.log(field.entityField.configuration);
    }*/
    let ret = false;
    if (field != null && field.entityField?.configuration != null && field.entityField.configuration.disabled != null) {
      ret = eval(field.entityField.configuration.disabled);
    }
    return ret;
  }

  isEditableField(component: any, field: any, form: UntypedFormGroup, model: any) {
    let editable = true;

    //si el componente no es editable
    if (!this.isEditable(component, model)) return false;

    //si campo de solo lectura o no modificable
    if (field.readonly || field.entityField.unmodifiable) {
      if (field.readonly) {
        return false;
      }
      //Si es unmodifiable, comprobamos si es un filtro, si no lo es, lo bloqueamos. sino NO
      if (component.code.indexOf('.filters') < 0) return false;
    }
    
    //Si tienes superpermisos no se comprueba nada más.
    if (component != null && component.entity == "organization" && this.loginService.hasPermission("ORGANIZATIONS_SUPERADMIN")) return true;
    if (component != null && component.entity == "contact" && this.loginService.hasPermission("ORGANIZATIONS_SUPERADMIN")) return true;
    if (component != null && component.entity == "reports" && this.loginService.hasPermission("REPORTS_SUPERADMIN")) return true;
    if (component != null && component.entity == "transactions" && this.loginService.hasPermission("TRANSACTIONS_SUPERADMIN")) return true;
    if (component != null && component.entity == "users" && this.loginService.hasPermission("USERS_SUPERADMIN")) return true;
    if (component != null && component.entity == "zones" && this.loginService.hasPermission("ZONES_SUPERADMIN")) return true;
    //TODO: probar si las transacciones customizadas se llaman componen.entity == transactions o el nombre
    if (component != null && component.entity == "oportunity" && this.loginService.hasPermission("OPORTUNITIES_SUPERADMIN")) return true;
    if (component != null && component.entity == "sale" && this.loginService.hasPermission("SALES_SUPERADMIN")) return true;
    if (component != null && component.entity == "task" && this.loginService.hasPermission("TASKS_SUPERADMIN")) return true;
    if (component != null && component.entity == "taskHistory" && this.loginService.hasPermission("TASKS_SUPERADMIN")) return true;
    if (component != null && component.entity == "transactionLine" && (this.loginService.hasPermission("TRANSACTIONS_SUPERADMIN") || this.loginService.hasPermission("OPORTUNITIES_SUPERADMIN") || this.loginService.hasPermission("SALES_SUPERADMIN"))) return true;


    //si hay modelo de datos cargado, revisamos validaciones de datos
    if (model.id > 0) {
      //si eres responsable
      editable = this.loginService.isUserResponsible(model);
      if (!editable && this.loginService.isUserSubordinate(model)) editable = true;

      let field_editable_by = field.editable_by ?? 'all';
      if (field_editable_by == 'user' && !editable) {
        //fin
      } else if (field_editable_by == 'all' && !editable) {
        //validar por zonas, lo ven todos pero no eres reponsable
        //comprobar si es de mi zona y tengo permiso
        if (this.loginService.isUserZone(model) && this.loginService.isUserZoneWritable(component.entity)) editable = true;
      }
    }

    //ejecutar disable personalizado del campo
    if (editable && this.isDisabledFieldCustom(field, component)) editable = false;



    let control = form.get(field.entityField.model_property);
    if (control != null && !editable) {
      control.disable();
    } else if (control != null && editable) {
      control.enable();
    }

    if(field.entityField.model_property=="country_id") console.log("Editable", field.entityField.model_property, editable);

    return editable;
  }

}
